import React, { Component, createRef } from 'react';
import Formsy from 'formsy-react';
import { Container, Grid, Dimmer, Loader } from 'semantic-ui-react'

import './ServiceForm.less'
import _, {
    capitalize as _capitalize,
    orderBy as _orderBy,
    isEmpty
} from 'lodash';


import arrow_down from '../../assets/images/newui/arrow-down.svg'
import arrow_up from '../../assets/images/newui/arrow-up.svg'

import DGTextbox from '../../components/FormControls/Textbox/DGTextbox';
import '../../components/FormControls/Checkbox/DGCheckbox.less'
import DGRadioGroup from '../../components/FormControls/RadioGroup/DGRadioGroup'
import DGTextarea from '../../components/FormControls/Textarea/DGTextarea';
import DGUploadFile from '../../components/FormControls/UploadFile/DGUploadFile';
import DGPromo from 'components/FormControls/Promo/DGPromo';
import DGMultiCheckBoxGroup from 'components/FormControls/MultiCheckBoxGroup/DGMultiCheckBoxGroup';
import GeneralError from 'components/GeneralError/GeneralError';
import close from '../../assets/images/newui/close.png'

const initialState = {

    windowWidth: 0,
    windowHeight: 0,
    formData: {},
    files: []
};

class ServiceForm extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;

        this.formRef = createRef();
        this.serviceErrorRef = createRef();

        for (let i = 0; i < 50; i++) {
            this['section_' + i] = createRef();
        }

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

        this.uploadCollapsibleButtonRef = createRef();
        this.promoCollapsibleButtonRef = createRef();

        this.uploadCollapsibleContainerRef = createRef();
        this.promoCollapsibleContainerRef = createRef();

        this.promoContainerShown = false;
        this.uploadContainerShown = false;
    }

    updateWindowDimensions() {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    componentDidMount() {
        try {
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);

            this.setState({ formData: this.props.formData });
        }
        catch {

        }
    }

    onUploadCollapsibleButtonClick = () => {

        if (this.uploadContainerShown) {
            this.uploadCollapsibleContainerRef.current.classList.add('hide');
            this.uploadCollapsibleContainerRef.current.classList.remove('show');

            this.uploadCollapsibleButtonRef.current.src = arrow_down;
            this.uploadCollapsibleButtonRef.current.classList.add('expand');
            this.uploadCollapsibleButtonRef.current.classList.remove('collapse');

        }
        else {
            this.uploadCollapsibleContainerRef.current.classList.add('show');
            this.uploadCollapsibleContainerRef.current.classList.remove('hide');

            this.uploadCollapsibleButtonRef.current.src = arrow_up;
            this.uploadCollapsibleButtonRef.current.classList.add('collapse');
            this.uploadCollapsibleButtonRef.current.classList.remove('expand');

        }
        this.uploadContainerShown = !this.uploadContainerShown;

    }

    onPromoCollapsibleButtonClick = () => {

        if (this.promoContainerShown) {
            this.promoCollapsibleContainerRef.current.classList.add('hide');
            this.promoCollapsibleContainerRef.current.classList.remove('show');
            this.promoCollapsibleButtonRef.current.src = arrow_down;
            this.promoCollapsibleButtonRef.current.classList.add('expand');
            this.promoCollapsibleButtonRef.current.classList.remove('collapse');
        }
        else {

            this.promoCollapsibleContainerRef.current.classList.add('show');
            this.promoCollapsibleContainerRef.current.classList.remove('hide');
            this.promoCollapsibleButtonRef.current.src = arrow_up;
            this.promoCollapsibleButtonRef.current.classList.add('collapse');
            this.promoCollapsibleButtonRef.current.classList.remove('expand');
        }
        this.promoContainerShown = !this.promoContainerShown;


    }

    get formPages() {
        const { formData } = this.state || {};

        if (!formData) {
            return [];
        }
        return _orderBy(formData.formPages, 'pageOrder');
    }

    getSortedSection = (page = {}) => {
        const { sections } = page;
        if (!sections) {
            return [];
        }
        return _orderBy(sections, 'sectionOrder');
    };

    getSortedFields = (section = {}) => {
        const { fields } = section;
        if (!fields) {
            return [];
        }
        return _orderBy(fields, 'fieldOrder');
    };

    onFileUpdate = (files) => {
        this.setState({ files: files }, () => {

        })
    }

    renderPage = (page, pageIndex) => {

        const sections = this.getSortedSection(page);
        return (<React.Fragment key={`sfd_page_${pageIndex} `}>

            {
                sections.map(this.renderSections)
            }

            {this.props.showImageUpload && this.props.showImageUpload === true &&
                <div className="section-container collapsible">
                    <img src={arrow_down} onClick={this.onUploadCollapsibleButtonClick} ref={this.uploadCollapsibleButtonRef} />
                    <div className="section-header" onClick={this.onUploadCollapsibleButtonClick}>
                        Picture Upload
                </div>

                    <div className="section-fields collapsible hide" ref={this.uploadCollapsibleContainerRef}>
                        <DGUploadFile onDrop={this.onFileUpdate} onRemove={this.onFileUpdate} fileType="images" maxFileCount={6} minFileCount={0}></DGUploadFile>
                    </div>

                </div>
            }

            {this.props.showApplyPromoCode && this.props.showApplyPromoCode === true &&
                <div className="section-container collapsible">
                    <img src={arrow_down} onClick={this.onPromoCollapsibleButtonClick} ref={this.promoCollapsibleButtonRef} />
                    <div className="section-header" onClick={this.onPromoCollapsibleButtonClick}>
                        Promo Code
                </div>
                    <div className="section-fields collapsible hide promo" ref={this.promoCollapsibleContainerRef}>
                        <DGPromo placeholder="Enter promo code" serviceID={this.state.serviceId} onPromoApplication={this.onPromoApplication} onPromoRemoval={this.onPromoRemoval}></DGPromo>
                    </div>
                </div>
            }

        </React.Fragment>)

    };

    renderSections = (section, sectionIndex) => {
        const { windowWidth, windowHeight } = this.state;

        const fields = this.getSortedFields(section);

        let required = false;

        if (section.type === 'radio' || section.type === 'multi') {
            required = _.some(fields, { 'required': true });


        }

        switch (section.type) {

            case 'radio':

                return (
                    <React.Fragment>
                        <div className="section-container">
                            <div className="section-header" ref={this['section_' + section.sectionID]}>
                                {section.headerText}
                            </div>
                            <div className="section-fields">

                                <DGRadioGroup key={`radio_${section.sectionID}`}
                                    {...{
                                        required: required

                                    }}

                                    validationErrors={{
                                        isDefaultRequiredValue: 'Please select one of these',
                                    }}
                                    name={`${section.sectionID}`}
                                    fields={fields}
                                    sectionID={section.sectionID}
                                >
                                </DGRadioGroup>

                            </div >
                        </div>

                    </React.Fragment >
                );
            case 'none':
                let fieldWidthOnLargeDevices = 0;
                if (fields.length === 1) {
                    fieldWidthOnLargeDevices = 16;
                }
                else {
                    fieldWidthOnLargeDevices = 8;
                }
                return (
                    <React.Fragment>
                        <div className="section-container">
                            <div className="section-header" ref={this['section_' + section.sectionID]}>
                                {section.headerText}
                            </div>
                            <div className="section-fields">
                                <Grid>
                                    {fields.map((field, fieldIndex) => {
                                        return (
                                            <Grid.Column key={`grid_column_${fieldIndex}`} computer={fieldWidthOnLargeDevices} mobile={16} tablet={fieldWidthOnLargeDevices}>
                                                <DGTextbox
                                                    key={`textbox_${fieldIndex}`}
                                                    sectionID={section.sectionID}
                                                    fieldID={field.fieldID}
                                                    innerRef={(c) => {
                                                        return c;
                                                    }}
                                                    name={`${section.sectionID}_${field.fieldID} `}
                                                    label={`${field.name} `}
                                                    {...{

                                                        required: field.required,
                                                        maxLength: field.maxLength,
                                                        placeholder: (field.placeholder ? field.placeholder : ''),

                                                    }}

                                                    value={field.value}

                                                    validationErrors={{
                                                        isDefaultRequiredValue: `${field.name} is required`

                                                    }}

                                                ></DGTextbox>
                                            </Grid.Column>
                                        )
                                    })}
                                </Grid>

                            </div>
                        </div>
                    </React.Fragment>
                )
            case 'notes':

                return (
                    <React.Fragment>
                        <div className="section-container" ref={this['section_' + section.sectionID]}>
                            <div className="section-header">
                                {section.headerText}
                            </div>
                            <div className="section-fields">
                                <Grid>
                                    {fields.map((field, fieldIndex) => {
                                        return (
                                            <Grid.Column computer={16} mobile={16}>
                                                <DGTextarea
                                                    key={`textarea_${fieldIndex}`}
                                                    sectionID={section.sectionID}
                                                    fieldID={field.fieldID}
                                                    name={`${field.name} `}
                                                    label={`${field.name} `}
                                                    {...{

                                                        required: field.required,
                                                        maxLength: field.maxLength,
                                                        placeholder: (field.placeholder ? field.placeholder : ''),

                                                    }}

                                                    value={field.value}

                                                    validationErrors={{
                                                        isDefaultRequiredValue: `${field.name} is required`

                                                    }}

                                                ></DGTextarea>
                                            </Grid.Column>
                                        )
                                    })}
                                </Grid>

                            </div>
                        </div>
                    </React.Fragment>
                )
            case 'multi':
                
                return (
                    <React.Fragment>
                        <div className="section-container" ref={this['section_' + section.sectionID]}>
                            <div className="section-header">
                                {section.headerText}
                            </div>
                            <div className="section-fields">
                                <DGMultiCheckBoxGroup key={`radio_${section.sectionId}`}

                                    {...{
                                        required: required

                                    }}

                                    validationErrors={{
                                        isDefaultRequiredValue: 'Please select one of these',
                                    }}
                                    name={`${section.sectionID}`}
                                    sectionID={section.sectionID}
                                    fields={fields}
                                >



                                </DGMultiCheckBoxGroup>

                            </div>
                        </div>

                    </React.Fragment>
                );

        }


    };


    onInvalidSubmit = (model, resetForm, invalidateForm) => {

        //logSubmitFormClicked(service, this.props.currentUser, 0);
        if (this.formRef && this.formRef.current) {
            const { inputs } = this.formRef.current;


            for (let i = 0; i < inputs.length; i++) {
                const input = inputs[i];

                if (!input.isValid()) {
                    const sectionID = input.props.sectionID;

                    this['section_' + sectionID].current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });

                    break;
                }
            }
        }
    }

    onValidSubmit = () => {

        let { formData, service, files } = this.state;

        //let clonedFormData = {...formData};

        let page = formData.formPages[0];
        
        if (this.state.promoCode && !_.isEmpty(this.state.promoCode)) {
            formData.code = this.state.promoCode;
        }

        //formData.photos = files;

        try {
            if (this.formRef && this.formRef.current) {
                const { inputs } = this.formRef.current;

                const sections = page.sections;
                //page.sections = sections;

                
                for (let i = 0; i < inputs.length; i++) {
                    const input = inputs[i];
                    const inputValue = input.getValue();
                    const sectionID = input.props.sectionID;
                    let section = _.find(sections, (sec) => {
                        return (sec.sectionID == sectionID);
                    }, 0);



                    const fieldID = input.props.fieldID;
                    if (fieldID) {

                        let field = _.find(section.fields, (fld) => {
                            return (fld.fieldID == fieldID);
                        }, 0);

                        field.value = inputValue;
                    }
                    else {
                        
                        if (section.type === 'multi') {
                            const selectedFields = _.filter(section.fields, (field) => {
                                return (_.indexOf(inputValue, field.fieldID.toString()) >= 0)
                            });

                            _.forEach(selectedFields, (field) => {
                                field.value = 'checked';
                            });

                            const unselectedFields = _.filter(section.fields, (field) => {
                                return (_.indexOf(inputValue, field.fieldID.toString()) === -1)
                            })

                            _.forEach(unselectedFields, (field) => {

                                field.value = '';

                            });
                        }
                        else if (section.type === 'radio') {
                            
                            const selectedFields = _.filter(section.fields, (field) => {
                                return (field.fieldID.toString() == inputValue)
                            });

                            _.forEach(selectedFields, (field) => {
                                field.value = 'checked';
                            });

                            const unselectedFields = _.filter(section.fields, (field) => {
                                return (field.fieldID.toString() != inputValue)
                            })

                            _.forEach(unselectedFields, (field) => {

                                field.value = '';

                            });
                        }
                        
                    }

                }
            }

            
            this.setState({ formData: formData }, () => {
                if (this.props.onValidSubmit)
                this.props.onValidSubmit(this.state.formData, this.state.files);
                
            });

            //this.compressImagesAndSubmitForm();
            
        }
        catch (error) {
            this.setState({ showLoading: false, showServiceSubmissionErrorMessage: true, serviceSubmissionErrorMessage: error, convertingImages: false }, () => {
                if (this.serviceErrorRef) {
                    this.serviceErrorRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            });
        }



    }

    componentDidUpdate(prevProps) {
        if (prevProps.formData != this.props.formData) {
            this.setState({ formData: this.props.formData });
        }
    }

    onCancel = () => {
        if (this.props.onCancel)
            this.props.onCancel();
    }


    render() {
        return (
            <div>
                <React.Fragment>
                    {this.formPages && !isEmpty(this.formPages) &&
                        <div className="form-container">
                            <Grid>
                                <Grid.Column textAlign="right">
                                    <div><img src={close} className="btn-close" onClick={this.onCancel} /> </div>
                                </Grid.Column>
                            </Grid>
                            <Formsy ref={this.formRef} onInvalidSubmit={this.onInvalidSubmit} onValidSubmit={this.onValidSubmit}>

                                {this.formPages.map(this.renderPage)}


                                {this.state.showServiceSubmissionErrorMessage &&
                                    <div className="section-container" style={{ marginTop: '20px' }} ref={this.serviceErrorRef}>

                                        <GeneralError message={this.state.serviceSubmissionErrorMessage} />
                                    </div>
                                }
                                <div className="section-container" style={{ marginTop: '20px' }}>
                                    <div className="section-header">
                                        <button type="submit" className="button-submit">
                                            <span>Submit</span></button>

                                        {/* <button type="button" className="button-cancel" onClick={this.onCancel}>
                                            <span>Cancel</span></button> */}
                                    </div>
                                </div>
                            </Formsy>
                        </div>
                    }
                </React.Fragment>
            </div>
        )
    }
}

export default ServiceForm
